import { sortBy } from 'lodash';
import { FETCH_CONFIGS, FETCH_CAMERA } from './types';

const initialState = {
  isFetching: false,
  cameras: [],
  error: null,
};

const sortCamerasByKey = (cameras) => sortBy(cameras, (cam) => {
  const num = parseInt(cam.cameraKey.replace(/\D/g, ''), 10);
  return Number.isNaN(num) ? cam.cameraKey : num;
});

export default (state = initialState, { type, payload = {} } = {}) => {
  switch (type) {
  case FETCH_CAMERA: {
    const { error, camera } = payload;
    let newCameras = null;

    if (camera) {
      const { cameraKey: newCameraKey } = camera;
      const filteredCameras = state.cameras.filter(({ cameraKey }) => cameraKey !== newCameraKey);
      newCameras = sortCamerasByKey([...filteredCameras, camera]);
    }

    return {
      ...state,
      isFetching: !error && !camera,
      cameras: newCameras || state.cameras,
      error,
    };
  }
  case FETCH_CONFIGS: {
    const { error, cameras } = payload;
    const sortedCameras = cameras ? sortCamerasByKey(cameras) : state.cameras;

    return {
      ...state,
      isFetching: !error && !cameras,
      cameras: sortedCameras,
      error,
    };
  }
  default: {
    return state;
  }
  }
};
